import React from 'react';

export default () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 0C3.15 0 0 3.15 0 7C0 10.85 3.15 14 7 14C10.85 14 14 10.85 14 7C14 3.15 10.85 0 7 0ZM7 1.75C8.155 1.75 9.205 2.1175 10.0625 2.73L2.73 10.0625C2.1175 9.205 1.75 8.155 1.75 7C1.75 4.095 4.095 1.75 7 1.75ZM11.27 3.9375C11.8825 4.795 12.25 5.845 12.25 7C12.25 9.905 9.905 12.25 7 12.25C5.845 12.25 4.795 11.8825 3.9375 11.27L11.27 3.9375V3.9375Z" fill="currentColor" />
  </svg>
);
